import Rails from '@rails/ujs';

Rails.start();

// Ceci force le focus sur l'autocomplete quand la page se recharge
document.addEventListener('product-suggestion:autocomplete-created', function() {
    document.querySelector('.aa-input').focus()
});

import './jquery'
import 'bootstrap-sass/assets/javascripts/bootstrap.js'

import './autocomplete.jquery.min.js'
import './brands.js'
import './jquery.svg.pan.zoom.js'
import './pricing_requests.js'
import './product_families.js'
import './product_search.js'
import './products.js'
import './purchase_order_imports.js'
import './purchase_orders.js'
import './warehouses.js'
import './welcome.js'
import './admin/exploded_views.js'
import './admin/bootstrap-tagsinput.js'

import "./controllers"

import 'bootstrap-select'
import 'bootstrap-select/js/i18n/defaults-fr_FR.js'
//import "trix"
//import "@rails/actiontext"

